/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes, { elementType } from 'prop-types';
import { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from '@material-ui/core/Checkbox';
import { Link } from 'react-router-dom';
import AlertDialog from '../../components/AlertDialog/AlertDialog';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ImportExportIcon from '@material-ui/icons/ImportExport';

const styles = theme => ({
  actionsColumn: {
    width: 200,
    textAlign: 'center',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  selected: {
    paddingLeft: '10px',
    fontWeight: theme.typography.fontWeightStrong,
  },
  // premium: {
  //   paddingLeft: '10px',
  //   fontWeight: theme.typography.fontWeightStrong,
  // },
  disable: {
    color: theme.palette.grey[500],
  },
  paddingCheckbox: {
    padding: '0 12px',
  },
});

class SelectTable extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 5,
    openDialog: false,
    openModal: false,
    reverseItens: false,
    resetSort: false,
    alphabeticalSort: false,
    Titletable: ''
  };

  onCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleOpenDialog = () => {
    this.setState({ openDialog: true });
  }

  onCloseModal = () => {
    this.setState({ openModal: false });
  }

  handleOpenModal = () => {
    this.setState({ openModal: true });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  ResetSort = (column) => {
    // console.log(item.target.innerText)
    if (this.state.resetSort === false) {
      this.setState({ alphabeticalSort: true, resetSort: true, Titletable: column.name })
    } else {
      this.setState({ alphabeticalSort: false, resetSort: false ,Titletable:''})
    }
  };

  render() {
    const {
      classes,
      rows,
      columns,
      onSelectAll,
      onSelect,
      checkSelect,
      numSelected,
      loading,
      actions,
      independentActions,
      searchFields,
      searchQuery,
      PointMirrorReport,
      disableRow,
      hideCheckbox,
      listReport
    } = this.props;
    const { page, rowsPerPage, openDialog, openModal } = this.state;

    const amountColumns = columns.length + (actions ? 2 : 1);

    const filteredRows = rows.filter((row) => {
      let hasField = false;
      searchFields.forEach((searchField) => {
        if (row[searchField]) {
          hasField = hasField || row[searchField].toUpperCase().includes(searchQuery);
        }
      });
      return hasField;
    });


    let emptyMessage = null;
    if (!loading && (!rows.length || !filteredRows.length)) {
      emptyMessage = (
        <TableRow>
          <TableCell colSpan={amountColumns}>
            <Typography variant="body1" align="center">
              Nenhuma informação encontrada
            </Typography>
          </TableCell>
        </TableRow>
      );
    }
    let RowsFilter = filteredRows.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });


    const collator = new Intl.Collator('pt-Br', { numeric: true, sensitivity: 'base' });
    RowsFilter = this.state.alphabeticalSort === true ? [...filteredRows].sort((a, b) => {
      return collator.compare(a[this.state.Titletable], b[this.state.Titletable]);
    }) : RowsFilter;

    RowsFilter = this.state.Titletable == 'name' ? RowsFilter.reverse() : RowsFilter

    return (
      <React.Fragment>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.paddingCheckbox}>
                {hideCheckbox === true ? null : listReport == true ? '' :
                  <Checkbox
                    color="primary"
                    indeterminate={numSelected > 0 && numSelected < rows.length}
                    checked={Boolean(rows.length && numSelected === rows.length)}
                    onChange={PointMirrorReport ? this.handleOpenModal : (event, checked) => onSelectAll(event, checked, filteredRows)}
                  />
                }
              </TableCell>
              {columns.map((column, index) => (

                <TableCell key={index} className={classes.paddingCheckbox}>

                  {
                    <TableSortLabel
                      IconComponent={ImportExportIcon}
                      onClick={() => this.ResetSort(column)}
                    >
                      {column.label}
                    </TableSortLabel>
                  }
                </TableCell>
              ))}
              {independentActions || actions ? (
                <TableCell className={[classes.actionsColumn, classes.paddingCheckbox]}>
                  Ações
                </TableCell>
              ) : null}
            </TableRow>
            {loading ? (
              <tr>
                <TableCell padding="none" colSpan={amountColumns}>
                  <LinearProgress />
                </TableCell>
              </tr>
            ) : null}
          </TableHead>

          <TableBody>
            {emptyMessage ||
              RowsFilter.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                const rowActions = independentActions ? row.actions : actions;
                const isSelected = checkSelect(row.id);
                const disableField = disableRow ? null : ' ';
                return (
                  <TableRow key={row.id} selected={disableField && row[disableRow] ? isSelected : false} hover>
                    <TableCell className={classes.paddingCheckbox}>
                      <Checkbox
                        disabled={!PointMirrorReport ? false : isSelected ? false : numSelected == 2 ? true : false}
                        color="primary"
                        checked={disableField || row[disableRow] ? isSelected : false}
                        onClick={disableField || row[disableRow] ? event => onSelect(event, row.id, row.name, numSelected) : this.handleOpenDialog}
                      />
                    </TableCell>
                    {columns.map((column, index) => (
                      <TableCell key={index} className={[disableField || row[disableRow] ? null : classes.disable, classes.paddingCheckbox]}>

                        {typeof row[column.name] === 'boolean' ? row[column.name]
                          ? 'Ativado'
                          : 'Desativado'
                          : column.name === '_dtRef' || column.name === 'deletionDate' || (row[column.name] && column.name !== 'customName') ? row[column.name].split('-').reverse().join('/') : row[column.name] || 'Nenhuma'}
                      </TableCell>
                    ))}
                    {actions ? (
                      <TableCell className={[classes.actionsColumn, classes.paddingCheckbox]}>
                        {rowActions
                          ? rowActions.map((action, index) => (
                            <Tooltip key={index} title={action.name} placement="top-end">
                              <IconButton
                                onClick={() =>
                                  action.handleClick({
                                    id: row.id,
                                    name: row[columns[0].name],
                                  })
                                }
                                color="primary"
                              >
                                <action.icon />
                              </IconButton>
                            </Tooltip>
                          ))
                          : null}
                      </TableCell>
                    ) : null}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>

        <div className={classes.footer}>
          <Link style={{ textDecoration: 'none' }} to="/assinatura">
            <Typography color="primary" className={classes.selected}>
              {PointMirrorReport ? 'Seja assinante e gere quantos espelhos precisar.' : ''}    {numSelected ? `${numSelected} itens selecionados` : null}
            </Typography>
          </Link>
          <TablePagination
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            labelRowsPerPage="Itens por página"
          />
        </div>

        <AlertDialog
          title="Atenção"
          text="Não é possível gerar relatório de um funcionário sem escala cadastrada"
          open={openDialog}
          onClose={this.onCloseDialog}
        />
        {PointMirrorReport ?
          < AlertDialog
            title="Atenção"
            text={<Link style={{ textDecoration: 'none' }} to="/assinatura">
              <Typography color="primary" className={classes.premium}>
                Seja assinante e gere quantos espelhos precisar.
              </Typography>
            </Link>}
            open={openModal}
            onClose={this.onCloseModal}
          >
          </AlertDialog> : ''}
      </React.Fragment >
    );
  }
}

SelectTable.propTypes = {
  disableRow: PropTypes.string,
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  searchFields: PropTypes.array,
};

SelectTable.defaultProps = {
  searchFields: [],
  disableRow: null,
};

export default withStyles(styles)(SelectTable);